import {
  SIGN_OUT_USER,
  REFRESH_TOKEN,
  SET_CURRENT_USER,
  GET_CURRENT_USER,
  LOGIN,
  RESET_PASSWORD,
} from '../types/authenticate';

export function getCurrentUser() {
  return { type: GET_CURRENT_USER };
}

export function requestCurrentUser() {
  return {
    type: SET_CURRENT_USER,
  };
}

export const login = (params = {}, callback) => ({
  type: LOGIN,
  params,
  callback,
});

export const resetPassword = (params = {}, callback) => ({
  type: RESET_PASSWORD,
  params,
  callback,
});

export const refreshToken = (params = {}, callback = null) => ({
  type: REFRESH_TOKEN,
  params,
  callback,
});

export const requestSignOut = (callback) => ({
  type: SIGN_OUT_USER,
  callback,
});
